import { useEffect, useState } from "react";
import scriptLoader from "../../../../../../utils/scriptLoader";
import { youtubeParser } from "../../../../../../utils/video-playlist";
import submit from "submit-form";
import SvgIcon from "../../../../../../parts/SvgIcon";
import AddPlaylistVideo from "./AddEditPlaylistVideo";

const youtubeRegex =
  /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;

const youtubeLongRegex =
  /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[^&\s\?]+(?!\S))\/)|(?:\S*v=|v\/)))([^&\s\?]+)/;

const URL_REGEX =
  /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

export const EditVideo = ({
  nameProps,
  urlProps,
  _indexProps,
  allVideos,
  playlist,
  key,
  id,
  setPlaylistEditFormState,
  playListEditFormState,
  statusStateProps,
  setvideosState,
}) => {
  //state to control if the video is in edit mode or not
  const [statusEditState, setStatusEditState] = useState("initial");
  //state to control the form
  const [formState, setFormState] = useState({
    name: nameProps,
    url: urlProps,
  });
  const { name, url } = formState;
  const youtubeId = youtubeParser(urlProps);

  /**
   * Reorder the videos
   */
  useEffect(() => {
    scriptLoader(
      "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js",
      () => {
        const dragImage = document.createElement("img");
        dragImage.src =
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        const sortable = new Sortable(
          document.querySelector(".principal-grabber-edit-div"),
          {
            animation: 350,
            handle: ".drag-handle",
            setData(dataTransfer) {
              dataTransfer.setDragImage(dragImage, 0, 0);
            },
            onEnd: (e) => {
              if (e.oldIndex === e.newIndex) return;

              const ordered = Array.from(
                document.querySelectorAll(".item-edit-grabber-container")
              ).map((element) => JSON.parse(element.id));

              setvideosState(ordered);
            },
          }
        );
      }
    );
  }, []);

  /**
   * Change the status to see if the video is in edit mode or not
   * @param {*} state
   */
  const handleChangeState = (state) => {
    setStatusEditState(state);
  };

  /**
   * Assign the value to the form's state
   * @param {*} param0
   */
  const handleInputChange = ({ target }) => {
    const newState = Object.assign({}, formState, {
      [target.name]: target.value,
    });
    setFormState(newState);
  };

  /**
   * Validate if the video's form is valid (if it is not a white text, if it is a valid url and if it is a valid youtube link)
   * @returns
   */

  const validationVideoSubmit = () => {
    if (
      formState.url.length > 0 &&
      URL_REGEX.test(formState.url) &&
      formState.name.length > 0 &&
      ((formState.url.includes("youtube") &&
        formState.url.includes("shorts")) ||
        youtubeLongRegex.test(formState.url))
    ) {
      return true;
    }
    return false;
  };

  /**
   * Create a video
   * @param {*} e
   */
  const handleSubmit = (e) => {
    e.preventDefault();

    const body = allVideos;
    body.splice(_indexProps, 1);
    body.splice(_indexProps, 0, formState);
    submit(`/actions/video-playlist/save/${playlist}`, {
      method: "POST",
      body: { videos: body },
    });
    setStatusEditState("initial");
  };

  /**
   * Delete a video
   * @param {*} e
   * @param {*} i
   * @returns
   */
  const handleDeleteVideo = (e, i) => {
    e.stopPropagation();
    e.preventDefault();

    if (
      process.browser &&
      !confirm("Are you sure you want to remove this video?")
    ) {
      return;
    }
    const filteredVideos = allVideos.filter((_, index) => index !== i);

    const newState = Object.assign({}, playListEditFormState, {
      videos: filteredVideos,
    });
    setPlaylistEditFormState(newState);

    submit(`/actions/video-playlist/save/${playlist}`, {
      method: "POST",
      body: { videos: filteredVideos },
    });
  };

  return (
    <>
      {statusEditState === "initial" ? (
        <div
          className="widget-edit-video-wrapper item-edit-grabber-container"
          key={key}
          id={id}
        >
          <div>
            <img
              src={`https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`}
              style={{}}
              alt="Thumbnail"
              loading="lazy"
            />
            <div>
              <p className="s2">{name}</p>
              <p className="p4">{url}</p>
            </div>
          </div>
          <div className="action-buttons">
            <button
              data-button-type="secondary"
              data-icon-only
              onClick={() => handleChangeState("edit")}
            >
              <SvgIcon src={"/img/new-icons/edit-pencil.svg"} />
            </button>
            <button
              data-button-type="secondary"
              data-icon-only
              onClick={(event) => handleDeleteVideo(event, _indexProps)}
            >
              <SvgIcon src={"/img/new-icons/red-trash.svg"} />
            </button>
          </div>

          {statusStateProps === "change-order" && (
            <div
              style={{
                height: "80px",
                position: "relative",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              data-col="1/7"
            >
              <div className="status-recipe">
                <img
                  width={20}
                  height={20}
                  src="/img/svg/drag-handle-icon.svg"
                  alt="delete"
                  className="drag-handle icon-white"
                />{" "}
              </div>
            </div>
          )}
        </div>
      ) : (
        <AddPlaylistVideo
          videoFormState={{ name, url }}
          handleInputVideoChange={handleInputChange}
          validationVideoSubmit={validationVideoSubmit}
          handleVideoSubmit={handleSubmit}
          setStatusEditState={setStatusEditState}
        />
      )}
    </>
  );
};
